import {
  Accordion,
  Card,
  CardHead,
  Header,
  HeaderArt,
  HeaderSub,
  HeaderTitle,
  List,
  Num,
  SecHead,
  Section,
  TwoCol,
  Wrap,
} from './guideUi';

/** 수하물 규정 — 네이티브 인포그래픽. */
const LuggageGuide = () => {
  return (
    <Wrap>
      <Header>
        <HeaderArt aria-hidden>
          <svg viewBox='0 0 48 48' fill='none'>
            <rect
              x='10'
              y='16'
              width='28'
              height='22'
              rx='4'
              fill='rgba(255,255,255,0.16)'
              stroke='#fff'
              strokeWidth='2'
            />
            <path
              d='M18 16v-3a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v3'
              stroke='#fff'
              strokeWidth='2'
              strokeLinejoin='round'
            />
            <path
              d='M18 22v10M30 22v10'
              stroke='#fff'
              strokeWidth='2'
              strokeLinecap='round'
            />
          </svg>
        </HeaderArt>
        <HeaderTitle>수하물 규정</HeaderTitle>
        <HeaderSub>안전한 여행을 위해 적재 기준을 확인하세요.</HeaderSub>
      </Header>

      <Section>
        <SecHead>
          <Num>1</Num> 기본 적재 안내
        </SecHead>
        <List>
          <li>
            차량 정원(승차인원)과 트렁크 용량 범위 내에서 수하물을 적재해
            주세요.
          </li>
          <li>안전을 위해 시야·운전을 방해하는 적재는 금지됩니다.</li>
        </List>
      </Section>

      <Section>
        <SecHead>
          <Num>2</Num> 이런 경우 확인하세요
        </SecHead>
        <TwoCol>
          <Card>
            <CardHead>낚시용품</CardHead>
            <List>
              <li>차량 오염·손상 방지를 위해 대여가 제한됩니다.</li>
            </List>
          </Card>
          <Card>
            <CardHead>반려동물</CardHead>
            <List>
              <li>일반 예약이 아닌 '펫과 함께' 경로로 이용해 주세요.</li>
            </List>
          </Card>
        </TwoCol>
      </Section>

      <Accordion num={3} title='유의사항'>
        <List>
          <li>
            오염·악취·파손을 유발하는 물품 적재로 발생한 청소·수리 비용은 고객
            부담입니다.
          </li>
          <li>
            대형·특수 수하물(서핑보드, 대형 캐리어 다수 등)은 차종에 따라 적재가
            어려울 수 있으니 예약 전 예약실로 문의해 주세요.
          </li>
        </List>
      </Accordion>
    </Wrap>
  );
};

export default LuggageGuide;
